<template>
  <div id="tabla-pendientes">
    <v-data-table
      :headers="headers"
      :items="cobrosPendientes.data"
      :page-count="cobrosPendientes.last_page"
      :page="cobrosPendientes.current_page"
      :server-items-length="cobrosPendientes.total"
      :sort-by="sortby"
      :sort-desc="sortdesc"
      :footer-props="{
        itemsPerPageOptions: [5]
      }"
      @update:options="getData($event)"
    >
      <template v-slot:[`item.contraparte`]="{ item }">
        <span>
          {{ (item.derechoClub !== null) ? 'Club' : 'Jugador' }}
        </span>
      </template>
      <template v-if="$can('M_jugadores_edita')" v-slot:[`item.actions`]="{ item }">
        <v-tooltip content-class="top" top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon medium class="mr-2" v-bind="attrs" v-on="on" @click.stop="goToPagar(item)">
              mdi-cash-plus
            </v-icon>
          </template>
          <span>Cobrar derecho</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    name: 'CobrosPendientesTabla',
    props: {
      monedaId: {
        type: Number,
        default: 0,
        required: true,
      },
      urlparametrizada: {
        type: String,
        default: '?page=&fmin=&fmax=&search=&tipoContrato=&contraparte=',
        required: false,
      },
    },
    data () {
      return {
        headers: [
          { text: 'Fecha cobro', align: 'start', sortable: true, value: 'vencimiento' },
          { text: 'Jugador', sortable: true, value: 'full_name' },
          { text: 'Tipo Contrato', value: 'tipoContrato' },
          { text: 'Club', value: 'club' },
          { text: 'Contraparte', value: 'contraparte' },
          { text: 'Cuota', value: 'cuota' },
          { text: 'Monto ', value: 'monto' },
          { text: 'Saldo', value: 'saldo' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
        ],
        TipoContratoSelec: undefined,
        contraparteSelected: '',
        contraparte: ['Jugador', 'Club'],
        calculandoTotal: false,
        cobrosPendientes: [],
        fechaMax: false,
        fechaMin: false,
        sortby: ['vencimiento'],
        sortdesc: [false],
        op: {},
      }
    },
    watch: {
      urlparametrizada () {
        this.getDataConTotal()
      },
    },
    created () {
      // this.getTotal()
    },
    methods: {
      getData (data) {
        this.op = data
        this.readDataFromAPI(data.page, data.sortBy, data.sortDesc)
      },
      getDataConTotal () {
        this.readDataFromAPI(1, this.op.sortBy, this.op.sortDesc)
        this.getTotal()
      },
      readDataFromAPI: async function (page = 1, sortBy, sortDesc) {
        this.$store.dispatch('axiosMod/getData', {
          url: '/api/derechos_pendientes/' + this.monedaId + '?page=' + page + this.urlparametrizada + '&sortBy=' + sortBy + '&sortDesc=' + sortDesc,
        }).then(response => {
          this.cobrosPendientes = response
        })
      },
      getTotal (page = 1) {
        this.calculandoTotal = true
        this.$store.dispatch('axiosMod/getData', {
          url: '/api/derechos_pendientes_total/' + this.monedaId + '?page=' + page + this.urlparametrizada,
        }).then(response => {
          this.calculandoTotal = false
          this.$emit('cambioTotal', { total: response.toFixed(2), moneda_id: this.monedaId })
        })
      },
      goToPagar: function (index) {
        this.$store.commit('dep/setCuotas', { payload: [index.id] })
        this.$router.push({ name: 'Cobros', params: { id: 0, mode: 'precargado', idJugador: index.jugador_id, idContrato: index.contrato_id, idDerecho: index.derecho_representante_id } })
      },
    },
  }
</script>
